export const FILESTACK_DEFAULT_CUSTOM_TEXT = {
  'A new page will open to connect your account.': 'A new page will open to connect your account.',
  Add: 'Add',
  'An error occurred. Please try again.': 'An error occurred. Please try again.',
  Circle: 'Circle',
  Completed: 'Completed',
  'Connect {providerName}': 'Connect {providerName}',
  'Connection Lost': 'Connection Lost',
  Crop: 'Crop',
  'Crop is required on images': 'Crop is required on images',
  'Cropped Images': 'Cropped Images',
  'Custom Source': 'Custom Source',
  'Deselect All': 'Deselect',
  Done: 'Done',
  'Drag and Drop, Copy and Paste Files': 'Drag and Drop, Copy and Paste Files',
  'Drop your files anywhere': 'Drop your files anywhere',
  Edit: 'Edit',
  'Edit Image': 'Edit Image',
  'Edited Images': 'Edited Images',
  'Enter a URL': 'Enter a URL',
  'Failed While Uploading': 'Failed While Uploading',
  'File {displayName} is not an accepted file type. The accepted file types are {types}':
    'File {displayName} is not an accepted file type. The accepted file types are {types}',
  'File {displayName} is too big. The accepted file size is less than {roundFileSize}':
    'File {displayName} is too big. The accepted file size is less than {roundFileSize}',
  Files: 'Files',
  Filter: 'Filter',
  'Go back': 'Go back',
  Images: 'Images',
  'Link (URL)': 'Link (URL)',
  Mask: 'Mask',
  'My Device': 'My Device',
  Next: 'Next',
  'No search results found for "{search}"': 'No search results found for "{search}"',
  'Our file upload limit is {maxFiles} {filesText}': 'Our file upload limit is {maxFiles} {filesText}',
  'Please enable your webcam to take a photo.': 'Please enable your webcam to take a photo.',
  'Record Audio': 'Record Audio',
  'Record Video': 'Record Video',
  Reset: 'Reset',
  'Retrying in': 'Retrying in',
  Revert: 'Revert',
  Rotate: 'Rotate',
  Save: 'Save',
  'Search images': 'Search images',
  'Select Files from {providerName}': 'Select Files from {providerName}',
  'Select Files to Upload': 'Select a Single File to Upload',
  'Select From': 'Select From',
  'Selected Files': 'Selected Files',
  'Sign Out': 'Sign Out',
  'Sign in with Google': 'Sign in with Google',
  'Take Photo': 'Take Photo',
  'This folder is empty.': 'This folder is empty.',
  'This image cannot be edited': 'This image cannot be edited',
  'To disconnect from {providerName} click "Sign out" button in the menu.':
    'To disconnect from {providerName} click "Sign out" button in the menu.',
  'Try again': 'Try again',
  'Try now': 'Try now',
  Upload: 'Upload',
  'Upload more': 'Upload more',
  Uploaded: 'Uploaded',
  Uploading: 'Uploading',
  'View/Edit Selected': 'View/Edit Selected',
  'We only extract images and never modify or delete them.': 'We only extract images and never modify or delete them.',
  'We suggest using Chrome or Firefox.': 'We suggest using Chrome or Firefox.',
  'Web Search': 'Web Search',
  'Webcam Disabled': 'Webcam Disabled',
  'Webcam Not Supported': 'Webcam Not Supported',
  'You need to authenticate with {providerName}.': 'You need to authenticate with {providerName}.',
  'Your current browser does not support webcam functionality.':
    'Your current browser does not support webcam functionality.',
  'more file': 'more file',
  'more files': 'more files',
  'or Drag and Drop, Copy and Paste Files': 'or Drag and Drop, Copy and Paste a Single File for Upload'
};

export function uuidGen() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
}
